module.exports = __webpack_public_path__ + "img/stripe-image.57c57982.jpeg";